// Accordion JS Scripts
var acc = document.getElementsByClassName("custom-accordion");
var i;

for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("custom-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      var inner = panel.querySelector('.panel-inner');
      panel.style.maxHeight = inner.scrollHeight + "px";
    }
  });
}

// Tab JS Scripts
function openTab(evt, tabSections) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" tab-active", "");
  }
  document.getElementById(tabSections).style.display = "block";
  evt.currentTarget.className += " tab-active";
}

// Get the element with id="defaultOpen" and click on it
document.addEventListener("DOMContentLoaded", function () {
  var defaultTab = document.getElementById("defaultOpen");
  if (defaultTab) {
    defaultTab.click();
  }
});
